
import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useRelationshipDiscoverer, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

import JSONPretty from 'react-json-pretty';

const dataProviderName = 'cars/contract';
const drawerRouteBase = 'contracts';

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer();
    const { userCapabilities, existingModules, appConfiguration } = useContext(AppContext);

    const { item, save, loadOne, destroy, doAction, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)
    const [endAt, setEndAt] = useState();
    useEffect(() => {
        if (!item?.data) return;
        if (item.data?.end_at) {
            setEndAt(item.data.end_at)
        } else if (item.data?.start_at && item.data?.contractDuration) {
            const endAt = new Date(item.data.start_at);
            endAt.setMonth(endAt.getMonth() + parseInt(item.data.contractDuration));
            endAt.setDate(endAt.getDate() - 1);

            setEndAt(endAt);
        }
    }, [item])

    const handleSave = (data) => {
        save({ ...data, filters: params.filters /*, canReloadCounter:false*/ }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    const [confirmRemoveReajustment, setConfirmRemoveReajustment] = useState();
    const handleRemoveReadjustment = (id) => {
        setConfirmRemoveReajustment(
            <Confirm
                oklabel={t("Remove")}
                okcallable={() => {
                    doAction({
                        action: 'removeExtension',
                        model: 'cars/contract',
                        data: { id: id }
                    }).then(() => closeDrawer());
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmRemoveReajustment(null) }}
                title={t("RemoveExtension")}>
                {t("Are you sure to remove this reajustment?")}
            </Confirm>
        );
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    ...item?.data,
                    legalEntity: discover('legalEntity'),
                    car: discover('car'),
                    end_at: endAt
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={!item?.data?.contractReajustmentEnd_at && userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={(item?.data?.contractIdentifier) ? item?.data?.contractIdentifier : (
                    (item?.data?.orderIdentifier) ? t('Order') + ' ' + item?.data?.orderIdentifier : (
                        (item?.data?.offerIdentifier) ? t('Offer') + ' ' + item?.data?.offerIdentifier : (
                            (item?.data?.configurationIdentifier) ? t('Configuration') + ' ' + item?.data?.configurationIdentifier : t('New contract')
                        )
                    )
                )}
                readonly={!!item?.data?.contractReajustmentEnd_at}
                header={
                    <InfoHeader
                        view={appConfiguration?.infoheaders?.contract ?? 'contract'}
                        item={appConfiguration?.infoheaders?.contract?.includes('vehicle') ? {...item?.data?.car, legalEntity: item?.data?.legalEntity, contractReajustmentStart_at: item?.data?.contractReajustmentStart_at, contractReajustmentEnd_at: item?.data?.contractReajustmentEnd_at } : item?.data }
                    />
                }
                rightButtons={item?.data?.contractReajustmentEnd_at ? [
                    <SplitButton
                        actions={[
                            {
                                disabled: false,// userCapabilities && !userCapabilities[dataProviderName + '.contractextension'] && item?.data?.childContract == null,
                                icon: "faCalendarPencil",
                                label: t('Modify Contract readjustment date'),
                                onClick: () => { activate(drawerRouteBase + '/contractExtensionModifyDate', { item: item?.data, child: item?.data?.childContract, detailStack: params.detailStack ?? {} }); }
                            },
                        ]}
                    />
                ] : [
                    <SplitButton
                        actions={[
                            // {
                            //     disabled:userCapabilities && !userCapabilities[dataProviderName+'.serviceassociation'],
                            //     icon:"faCreditCard",
                            //     label:t('Assign a Service'),
                            //     onClick:() => { activate(drawerRouteBase+'/serviceAssociation', {detailStack: params.detailStack ?? {}}); }
                            // },

                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.serviceassociation'],
                                icon: "faCreditCard",
                                label: t('Assign a Service'),
                                onClick: () => {
                                    activate('services/create', {
                                        assignedModel: "contract",
                                        contract: item?.data,
                                        legalEntity: item?.data?.legalEntity,
                                        assignment_start_at: new Date()
                                    });
                                }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.servicedissociation'],
                                icon: "faCreditCard",
                                label: t('Remove a Service'),
                                onClick: () => { activate(drawerRouteBase + '/serviceDissociation', { item: item }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.contractextension'] && item?.data?.parentContract != null,
                                icon: "faCalculator",
                                label: t('Contract adjustment'),
                                onClick: () => { activate(drawerRouteBase + '/contractExtension', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities['documents/document.genericfileassociation'],
                                icon: "faFile",
                                label: t('Add Contract Document'),
                                onClick: () => { activate(drawerRouteBase + '/genericFileAssociation', { contract: item?.data, multipart: true, filters: { data: { modelName: 'contracts', _id: item?.data?._id, keyName: item?.data?.contractIdentifier ?? item?.data?.orderIdentifier } } }); }
                            },
                            {
                                disabled: (userCapabilities && !userCapabilities[dataProviderName + '.contractextension']) || !item?.data?.parentContract,
                                icon: "faTrashCanXmark",
                                label: t('Remove this adjustment'),
                                onClick: () => { handleRemoveReadjustment(item.data.id) }
                            },
                            {
                                disabled: (userCapabilities && !userCapabilities[dataProviderName + '.delete']) || item?.data?.parentContract != null,
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            }
                        ]}
                    />
                ]}
                {...params}
            />
            {confirmDelete}
            {confirmRemoveReajustment}
        </>
    )
}

export default Detail;


